import owd from 'owd/owd';
import _ from 'underscore';

export default class Back extends owd.Component {
	init() {
        this.bodyHeight = this.dom.$body.height();
        this.windowHeight = this.dom.$window.innerHeight();
        
		this.bind();
	}

	bind() {
        this.on('scroll', this.dom.$window, _.throttle((e) => {
            const scrollTop = this.dom.$window.scrollTop() + (this.windowHeight / 2);
            const wh = this.windowHeight * 2;
            
            if(scrollTop >= wh) {
                this.$element.addClass('is-visible');
            } else {
                this.$element.removeClass('is-visible');
            }
        }, 100));
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('back', {
	component: Back
});